import { render, staticRenderFns } from "./filesManage.vue?vue&type=template&id=9f60b096&scoped=true&"
import script from "./filesManage.vue?vue&type=script&lang=js&"
export * from "./filesManage.vue?vue&type=script&lang=js&"
import style0 from "./filesManage.vue?vue&type=style&index=0&id=9f60b096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f60b096",
  null
  
)

export default component.exports